import { Box, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material'
import { buildErrorMessage } from '@shared/error'
import { i18WithParams as t } from '@shared/locale'
import { enqueueSnackbar } from 'notistack'
import { useParams } from 'react-router-dom'
import { ClientStoredPaymentMethodsService } from 'service-api/src/services/client_stored_payment_methods.service'
import { captureError } from 'service-api/src/shared'
import { PaymentCard } from '@views/profile/payment/cards/payment_card'
import { ExternalStoredPaymentMethodClientDto } from 'service-api/src/types/api'

export const PaymentMethods = ({
  storedPaymentMethods,
  isLoadingStoredPaymentMethods,
  onDeleteReFetchStoredPaymentMethods,
}: {
  storedPaymentMethods: ExternalStoredPaymentMethodClientDto[]
  isLoadingStoredPaymentMethods: boolean
  onDeleteReFetchStoredPaymentMethods: () => void
}) => {
  const { accountName: locationName = '' } = useParams()
  const theme = useTheme()
  const renderStyle = useMediaQuery(theme.breakpoints.down('md')) ? 'mobile' : 'desktop'
  const isMobile = renderStyle === 'mobile'

  if (isLoadingStoredPaymentMethods)
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Skeleton variant="rounded" width={'100%'} height={222} />
        <Skeleton variant="rounded" width={'100%'} height={222} />
      </Box>
    )

  if (!storedPaymentMethods?.length) {
    return (
      <Typography sx={{ pl: isMobile ? '16px' : 0 }} variant="body1">
        {t('profile.paymentMethod.noSavedPayments')}
      </Typography>
    )
  }

  const handleDelete = async (id: string) => {
    try {
      await ClientStoredPaymentMethodsService.delete(locationName, id)
      enqueueSnackbar(t('profile.paymentMethod.delete.success'), { variant: 'success' })
      onDeleteReFetchStoredPaymentMethods()
    } catch (error) {
      enqueueSnackbar(buildErrorMessage(error), { variant: 'error' })
      captureError(error as Error)
    }
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {storedPaymentMethods.map((paymentMethod) => (
          <PaymentCard key={paymentMethod.id} paymentMethod={paymentMethod} onDelete={handleDelete} />
        ))}
      </Box>
    </>
  )
}
